// The wonder-bi core release this code belongs to (WB-298), shown discreetly in the header bar.
// Written by the release job (ci/release/gitlab.mjs) in the chore(release) commit: do not edit.
export const CORE_VERSION = '5.7.1';
